export default "__VITE_ASSET__CCOfsm$U__"